import { forwardRef } from "react";
import { catchAsync } from "zeta-dom/util";
import { lock, locked, notifyAsync } from "zeta-dom/domLock";
import { classNames } from "zeta-dom-react";
import { Mixin, useLoadingStateMixin } from "brew-js-react";
import { IconNames, IconText } from "src/components/common";

export interface ButtonProps extends React.ComponentPropsWithRef<'button'> {
    label: string;
    icon?: IconNames;
    variant?: 'primary' | 'outlined' | 'link';
    disabled?: boolean;
    onClick?: (e: React.UIEvent) => any;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const { icon, label, variant, disabled, ..._props } = props;
    const mixin = useLoadingStateMixin();

    _props.type = _props.type || 'button';
    return (
        <button {..._props} {...Mixin.use(ref, mixin, classNames('eac-button', props.className, { variant: variant || 'outlined' }))} onClick={onClick} disabled={disabled}>
            {icon ? <IconText icon={icon}>{label}</IconText> : <span>{label}</span>}
        </button>
    );

    function onClick(e: React.UIEvent) {
        const element = e.currentTarget;
        if (!locked(element)) {
            let promise = props.onClick?.(e);
            if (promise instanceof Promise) {
                notifyAsync(element, catchAsync(lock(element, promise, true)));
            }
        }
    }
});
